import { trigger, style, transition, animate } from '@angular/animations';

export const slideDown = trigger('slideDown', [
  transition(':enter', [
    style({
      opacity: 0,
      transform: 'translateY(-10px)',
      transformOrigin: 'top'
    }),
    animate('200ms ease-out', style({
      opacity: 1,
      transform: 'translateY(0)'
    }))
  ]),
  transition(':leave', [
    animate('150ms ease-in', style({
      opacity: 0,
      transform: 'translateY(-10px)'
    }))
  ])
]);

export const fadeIn = trigger('fadeIn', [
  transition(':enter', [
    style({ opacity: 0 }),
    animate('200ms ease-out', style({ opacity: 1 }))
  ]),
  transition(':leave', [
    animate('150ms ease-in', style({ opacity: 0 }))
  ])
]);
